module.exports = __webpack_public_path__ + "media/images/captive_portal/Ticket-146beb18741dad62041a5f378d64000d.svg";